import { IconButtonTone } from '@design-system/atoms/icon-button/icon-button.types';
import { useTheme } from '@emotion/react';

export const useIconButtonIconColor = (tone: IconButtonTone = 'default', isDisabled: boolean) => {
  const theme = useTheme();

  if (isDisabled) {
    return theme.colors.technical.gray[15];
  }

  switch (tone) {
    case 'error':
      return theme.colors.status.error.dark;
    case 'warning':
      return theme.colors.status.warning.dark;
    case 'info':
      return theme.colors.status.info.dark;
    case 'neutral':
      return theme.colors.technical.black;
    case 'success':
      return theme.colors.primary.normal;
    default:
      return theme.colors.technical.gray[60];
  }
};
